import { InvitationCreateFormValues } from './types';

export const defaultValues: InvitationCreateFormValues = {
  step1: { invitationFor: null, invitationType: null },
  step2: {
    email: '',
    firstName: '',
    lastName: '',
    locale: '',
    location: '',
  },
  step3: { additionalData: [] },
  step4: { confirmation: false },
  step5: {},
};
